import { useState, type FormEvent } from 'react';
import type { TenantInput } from '../lib/api';
import { Button, ErrorText, Field, inputClass } from './ui';

/** Create (with slug) or edit (slug fixed) a tenant's descriptive fields. */
export function TenantForm({
  initial,
  editing,
  submitLabel,
  onSubmit,
}: {
  initial?: Partial<TenantInput>;
  editing?: boolean;
  submitLabel: string;
  onSubmit: (input: TenantInput) => Promise<void>;
}) {
  const [slug, setSlug] = useState(initial?.slug ?? '');
  const [name, setName] = useState(initial?.name ?? '');
  const [domain, setDomain] = useState(initial?.domain ?? '');
  const [plan, setPlan] = useState(initial?.plan ?? '');
  const [hostLabel, setHostLabel] = useState(initial?.hostLabel ?? '');
  const [notes, setNotes] = useState(initial?.notes ?? '');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await onSubmit({
        slug,
        name,
        domain,
        plan: plan || null,
        hostLabel: hostLabel || null,
        notes: notes || null,
      });
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={(e) => void submit(e)} className="space-y-3">
      <Field label="Nume firmă">
        <input
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={inputClass}
          placeholder="Genius Media"
        />
      </Field>
      {!editing && (
        <Field label="Slug" hint="Numele instanței de pe server, ca în /srv/firmio/<slug>">
          <input
            required
            value={slug}
            onChange={(e) => setSlug(e.target.value.toLowerCase())}
            className={inputClass}
            placeholder="geniusmedia"
          />
        </Field>
      )}
      <Field label="Domeniu">
        <input
          required
          value={domain}
          onChange={(e) => setDomain(e.target.value.toLowerCase())}
          className={inputClass}
          placeholder="geniusmedia.firmio.ro"
        />
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Plan">
          <input value={plan} onChange={(e) => setPlan(e.target.value)} className={inputClass} />
        </Field>
        <Field label="Server">
          <input
            value={hostLabel}
            onChange={(e) => setHostLabel(e.target.value)}
            className={inputClass}
            placeholder="76.13.9.219"
          />
        </Field>
      </div>
      <Field label="Note">
        <textarea
          rows={3}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className={inputClass}
        />
      </Field>
      <ErrorText error={error} />
      <div className="flex justify-end">
        <Button type="submit" disabled={busy}>
          {busy ? 'Se salvează…' : submitLabel}
        </Button>
      </div>
    </form>
  );
}
